import { render } from "./DadminGames.vue?vue&type=template&id=62d5baac"
import script from "./DadminGames.vue?vue&type=script&lang=js"
export * from "./DadminGames.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__